import strFunc from '@/lib/lyg/string';

function VideoArea(props:any){
  const myProps={
    video_info:{},
    videoXColumnArr:[],
    section_arr:[],
    video_arr:[],
    set_video_arr:(video_arr:any)=>{},
    openPreviewPopup:(video_info:any)=>{},
    ...props
  };

  let video_info=myProps.video_info;
  let video_arr=myProps.video_arr;
  let section_arr=myProps.section_arr;

  const onChangeRowData=(inOptObj:any)=>{
    if(inOptObj==undefined){inOptObj={};}
    let optObj={
      key:"",
      value:"",
      row_num:0,
      ...inOptObj
    };
    let value=optObj["value"];
    let key=optObj["key"];
    let row_num=optObj["row_num"];
    if(key=="a_is_essential"){
      if(value){
        value="1";
      }else{
        value="";
      }
    }else if(key=="a_amount_num"){
      value=strFunc.comma(value);
    }

    let tmp_video_arr:any=[...video_arr];
    tmp_video_arr[row_num][key]=value;

    myProps.set_video_arr(tmp_video_arr);
  };

  const removeRowData=(row_num:number)=>{
    let tmp_video_arr=[];
    for(let i=0;i<video_arr.length;i++){
      if(i!=row_num){
        tmp_video_arr.push(video_arr[i]);
      }
    }
    myProps.set_video_arr(tmp_video_arr);
  };

  const moveOrderNum=(row_num:number,up_down:string)=>{
    let tmp_video_arr:any=[...video_arr];

    let next_row_num=row_num;
    if(up_down=="up"){
      next_row_num=row_num-1;
    }else if(up_down=="down"){
      next_row_num=row_num+1;
    }

    if(next_row_num<0){
      return false;
    }
    if(next_row_num>=tmp_video_arr.length){
      return false;
    }

    let now_row_data=tmp_video_arr[row_num];
    let change_row_data=tmp_video_arr[next_row_num];

    tmp_video_arr[row_num]=change_row_data;
    tmp_video_arr[next_row_num]=now_row_data;

    tmp_video_arr=getReSetOrderNum(tmp_video_arr);

    myProps.set_video_arr(tmp_video_arr);
  };

  const getReSetOrderNum=(tmp_video_arr:any)=>{
    for(let i=0;i<tmp_video_arr.length;i++){
      tmp_video_arr[i].a_order_num=i+1;
    }
    return tmp_video_arr;
  };

  const getColumnInputTag=(inOptObj:any)=>{
    if(inOptObj==undefined){inOptObj={};}
    let optObj={
      "key":"",
      "data":{},
      "row_num":0,
      ...inOptObj
    };
    let key=optObj["key"];
    let val_str="";
    if(optObj["data"][key]!=undefined){
      val_str=optObj["data"][key];
    }

    let tag_obj=(
      <span>{val_str}</span>
    );

    if(key=="a_section_seq"){
      let select_options=section_arr.map((section_info:any,section_idx:number)=>{
        return (
          <option value={section_info.a_seq} key={section_idx}>{section_info.a_title}</option>
        );
      });
      tag_obj=(
        <select value={val_str} style={{width:"98%"}} 
          onChange={(e:any)=>{onChangeRowData({
            key:key,
            value:e.target.value,
            row_num:optObj["row_num"],
          });}}
          >
          <option value="">선택없음</option>
          {select_options}
        </select>
      );
    }else if(key=="a_is_essential"){
      tag_obj=(
        <input type="checkbox" value="1" style={{width:"98%"}} 
          onChange={(e:any)=>{onChangeRowData({
            key:key,
            value:e.target.checked,
            row_num:optObj["row_num"],
          });}}
          checked={val_str=="1"}
        />
      );
    }else if(key=="a_url_sort"){
      tag_obj=(
        <select style={{width:"98%",border:"1px solid gray"}} 
          value={val_str}
          onChange={(e:any)=>{onChangeRowData({
            key:key,
            value:e.target.value,
            row_num:optObj["row_num"],
          });}}>

          <option value="">선택</option>
          {myProps.videoXColumnArr.select_arr.a_url_sort?.map((item:any,idx:number)=>{
            return (
              <option key={idx} value={item.value}>{item.text}</option>
            );
          })}

        </select>
      );
    }else if(key=="row_view_preview"){
      if(!strFunc.is_empty(optObj.data.a_url)){
        tag_obj=(
          <button className="btn-s2 btn-gray" onClick={()=>{myProps.openPreviewPopup(optObj.data);}}>미리보기</button>
        );
      }
    }else if(key=="a_memo"){
      tag_obj=(
        <textarea style={{width:"98%",height:30,border:"1px solid gray"}}
          value={val_str}
          onChange={(e:any)=>{onChangeRowData({
            key:key,
            value:e.target.value,
            row_num:optObj["row_num"],
          });}}
        ></textarea>
      );
    }else if(key=="row_view_manage"){
      tag_obj=(
        <div>
          <button className="btn-s btn-gray" onClick={()=>{moveOrderNum(optObj["row_num"],"up");}}>▲</button>
          <button className="btn-s btn-gray ml-2" onClick={()=>{moveOrderNum(optObj["row_num"],"down");}}>▼</button>
          <button className="btn-s btn-red ml-2" onClick={()=>{removeRowData(optObj["row_num"]);}}>X</button>
        </div>
      );
    }else if(key=="a_total_sec"||key=="a_complete_sec"){
      let time_json=strFunc.secondsToTimeJson(strFunc.uncomma(val_str));
      tag_obj=(
        <div>
          <input type="text" value={time_json.h} style={{width:22,textAlign:"center"}}
            onChange={(e:any)=>{
              let tmp_h=parseInt(strFunc.uncomma(e.target.value));
              if(tmp_h>=60){
                tmp_h=59;
              }
              if(tmp_h<0){
                tmp_h=0;
              }
              let tmp_val=strFunc.timeToSeconds(tmp_h,time_json.i,time_json.s);
              onChangeRowData({
                key:key,
                value:tmp_val,
                row_num:optObj["row_num"],
              });
            }}
           />:
          <input type="text" value={time_json.i} style={{width:22,textAlign:"center"}} 
            onChange={(e:any)=>{
              let tmp_i=parseInt(strFunc.uncomma(e.target.value));
              if(tmp_i>=60){
                tmp_i=59;
              }
              if(tmp_i<0){
                tmp_i=0;
              }
              let tmp_val=strFunc.timeToSeconds(time_json.h,tmp_i,time_json.s);
              onChangeRowData({
                key:key,
                value:tmp_val,
                row_num:optObj["row_num"],
              });
            }}
          />:
          <input type="text" value={time_json.s} style={{width:22,textAlign:"center"}} 
            onChange={(e:any)=>{
              let tmp_s=parseInt(strFunc.uncomma(e.target.value));
              if(tmp_s>=60){
                tmp_s=59;
              }
              if(tmp_s<0){
                tmp_s=0;
              }
              let tmp_val=strFunc.timeToSeconds(time_json.h,time_json.i,tmp_s);
              onChangeRowData({
                key:key,
                value:tmp_val,
                row_num:optObj["row_num"],
              });
            }}
          />
        </div>
      );
    }else{
      tag_obj=(
        <input type="text" value={val_str} style={{width:"98%"}} 
          onChange={(e:any)=>{onChangeRowData({
            key:key,
            value:e.target.value,
            row_num:optObj["row_num"],
          });}}
        />
      );
    }
    
    return tag_obj;
  };

  let video_td_arr=myProps.videoXColumnArr.x_column_list_arr.map((column:any,column_idx:number)=>{
    let tag_obj=getColumnInputTag({
      "key":column.key,
      "data":video_info,
      "row_num":video_info.row_num,
    });
    return (
      <td key={column_idx}>
        <div style={{width:column["width"],textAlign:"center"}}>
         {tag_obj}
        </div>
      </td>
    );
  });

  return (
    <tr>
      {video_td_arr}
    </tr>
  );
}
export default VideoArea;